export const TWITTER_REGEX_USERNAME =
    /^(https:\/\/(?:www.|mobile.)?twitter.com\/)?([a-zA-Z0-9_]{3,})$/;

export const NEXT_TOKEN_TWITTER = 'NEXT_TOKEN_POSTS_PAGE_TWITTER';

export const getNextTokenPageTwitter = () => {
    try {
        const userInfoString = localStorage.getItem(NEXT_TOKEN_TWITTER);
        if (!userInfoString) {
            return null;
        }
        if (!userInfoString) {
            throw Error('State Null');
        }
        return userInfoString;
    } catch (e) {
        console.error('User state next token Error', e);
        return null;
    }
};

export const setNextTokenPageTwitter = (next_token: string) => {
    localStorage.setItem(NEXT_TOKEN_TWITTER, next_token);
};

export const resetNextTokenPageTwitter = () => {
    localStorage.removeItem(NEXT_TOKEN_TWITTER);
};
